module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as1804-f65d5d5ad649cc242e121d66994d06d3.jpg";